import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteConcussionForm,
  getConcussionForms,
} from "../../actions/patientActions";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export const ConcussionFormDeleteConfirmModal = ({
  show,
  handleClose,
  id,
  token,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const deleteConcussion = () => {
    setLoading(true);
    dispatch(deleteConcussionForm(token, id))
      .then((response) => {
        toast.success("Concussion Form deleted successfully");
        setLoading(false);
        dispatch(getConcussionForms(token))
          .then((response) => {})
          .catch((error) => {
            history.push("/concussion-forms");
          });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error Deleting Concussion Form");
      });
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            Concussion Form Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this concussion form?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={deleteConcussion}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
